import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-department-info-controller',
  templateUrl: './department-info-controller.component.html',
  styleUrls: ['./department-info-controller.component.css']
})
export class DepartmentInfoControllerComponent implements OnInit {


  departmentInfoList:any = [];
  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  isLoading: any = false
  id: any

  addForm: any | FormGroup
  cid:any
  formSubmit: boolean = false;

  updateForm: any | FormGroup
  isEdit: boolean = false
  departmentInfo: any = [];

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }
  recordId: any = "";
  recordName: any = "";
  searchFilter: any = "";

  constructor(
    private generic_service: GenericService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.addForm = this.fb.group({
      departmentName: ['',[Validators.required]]
    })
    this.updateForm = this.fb.group({
      departmentName: ['',[Validators.required]]
    })
    this.getAllDepartment_info();
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page+1;
  }

  getAllDepartment_info(){
    this.isLoading = true
    this.generic_service.getAllDepartment_info().subscribe(
      (res:any)=> {
        console.log(res)
        this.departmentInfoList = res.response
        this.totalRecords = res.response.length
        this.isLoading = false
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getDepartment_infoById(departmentInfoId:any){
    this.generic_service.getDepartment_infoById(departmentInfoId).subscribe(
      (response:any)=>{
        this.departmentInfo = []
        this.departmentInfo.push(response.response)
        this.updateForm.patchValue({
          departmentName: response.response.departmentName
        })
        this.isEdit = true
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalAdd")?.click()
    document.getElementById("closeModalUpdate")?.click()
    document.getElementById("closeModalDelete")?.click()
  }

  deleteDepartment_info(){
    this.generic_service.deleteDepartment_info(this.id).subscribe(
      (response:any)=>{
        this.toastr.success(response.message)
        this.getAllDepartment_info();
        this.cancelModel();
      },
      (err:any)=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteIdSelect(id:any,list: any){
    this.id = id
    this.recordId = list.departmentInfoId
    this.recordName = list.departmentName
  }

  closeModal(){
    this.addForm.reset()
    this.updateForm.reset()
    this.formSubmit = false
    this.isEdit = false
  }

  addDepartment_info(){
    this.formSubmit = true;
    if(!this.addForm.valid){
      this.toastr.error("Please fill in all required fields");
      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "departmentName": this.addForm.get('departmentName').value,
      "cid": Number(this.cid),
    }

    console.log(body)
    this.generic_service.addDepartment_info(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        this.addForm.reset()
        this.cancelModel()
        this.getAllDepartment_info();

        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  updateDepartment_info(){
    this.formSubmit = true;
    if(!this.updateForm.valid){
      this.toastr.error("please fill required fields");
      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.departmentInfo[0].id,
      "departmentInfoId": this.departmentInfo[0].departmentInfoId,
      "departmentName": this.updateForm.get('departmentName').value,
      "cid": Number(this.cid),
    }
    console.log(body)
    this.generic_service.updateDepartment_info(body).subscribe(
      (response:any)=>{
        this.isEdit = false
        this.getAllDepartment_info();
        this.cancelModel()
        this.formSubmit = false;
        this.updateForm.reset()
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }


  clearData(){
    this.recordId = "";
    this.recordName = "";
  }

  refreshAll(){
    // this.page = 1
    this.searchFilter = ""
    this.getAllDepartment_info();
    this.onTableDataChange({
      first: 0,
      rows: this.tableSize,
      page: 0,
      pageCount: Math.ceil(this.totalRecords / this.tableSize)
    });

  }


  getAllDepartmentInfosByWildSearch(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getAllDepartmentInfosByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.departmentInfoList = []
          this.totalRecords = 0
          return
        }
        this.departmentInfoList = res.response
        this.totalRecords = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

}
